export const ehrNoteAction = {
  setCurrentEHRNote: (state, action) => {
    state.currentEhrNote = action.payload;
  },

  loadEHRNoteList: (state, action) => {
    state.ehrNoteList = action.payload;
    state.currentEhrNote = {};
  },
  onEHRNoteChange: (state, action) => {
    state.currentEhrNote = action.payload;
  },
  onEHRNoteInputFocus: (state, action) => {
    state.ehrNoteFocused = action.payload;
  },
  cancelEHRNote: (state, action) => {
    const { focused } = action.payload;

    state.currentEhrNote = {};
    state.ehrNoteFocused = focused;
  },
  setCanEditEHRNote: (state, action) => {
    state.canEditEHRNote = action.payload;
  },
  resetEHRNotes: (state) => {
    state.ehrNoteList = [];
    state.ehrNoteExpanded = false;
    state.currentEhrNote = {};
    state.ehrNoteSubmitting = false;
    state.ehrNoteFocused = false;
    state.canEditEHRNote = false;
  },
};
